// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subNav-selection-tab .nuxt-link-active p,.subNav-selection-tab .nuxt-link-exact-active p{background-color:#007c86;color:#fff}", ""]);
// Exports
module.exports = exports;
